// src/components/LanguageSwitcher.js
import React from "react";
import { useLanguage } from "../../../context/language/LanguageContext";
import styles from "./LanguageSwitcher.module.css";

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className={styles.container}>
      <button
        className={`${styles.button} ${language === "en" ? styles.activeButton : ""}`}
        onClick={() => toggleLanguage("en")}
      >
        EN
      </button>
      <button
        className={`${styles.button} ${language === "ar" ? styles.activeButton : ""}`}
        onClick={() => toggleLanguage("ar")}
      >
        AR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
